import { z } from 'zod'

export const OrderLimitReachedSchema = z.object({
  errorResolutionType: z.literal('ORDER_LIMIT_REACHED'),
})
